import "./logo.css";
import logoIcon from "assets/images/CashD-logo-full.svg";
import React from "react";

const LogoMain = () => {
  return <>{<img src={logoIcon} alt="CashD" width="200" />}</>;
};

export default React.memo(LogoMain);
